import classNames from 'classnames';
import { isEmpty } from 'lodash';
import React, { HTMLAttributes } from 'react';

import styles from './index.module.less';

interface VideoCoverProps extends HTMLAttributes<HTMLDivElement> {
  src: string;
  width?: string;
  height?: string;
  outerClassName?: string;
  innerClassName?: string;
  hasInner?: boolean;
}

/**
 * 主要为竖屏封面添加 blur 背景，以形成视觉上的横版封面
 * 也可以在半遮罩之上展示时长
 */
const Cover: React.FC<VideoCoverProps> = ({
  src,
  width,
  height,
  className,
  outerClassName,
  children,
  innerClassName,
  hasInner = false,
  onClick,
}) => (
  <div
    className={classNames(styles.cover, className)}
    style={{ width, height, background: isEmpty(src) ? undefined : 'transparent' }}
    onClick={onClick}
  >
    <div
      className={classNames(outerClassName, styles.outer)}
      style={{
        background: src
          ? `url(${src}) transparent 50% / cover no-repeat`
          : 'transparent',
      }}
    ></div>
    {hasInner ? (
      <div className={classNames(innerClassName, styles.inner)}>
        {src ? <img src={src} alt="" width="auto" height={height} /> : null}
      </div>
    ) : null}
    {children}
  </div>
);

export default Cover;
